import { useState, useEffect } from 'react'
import { generateOrders } from '@/utils/generateData'
import { Order } from '@/types'
import { OrderTrackingTable } from '@/components/orders/OrderTrackingTable'
import { DashboardSummary } from '@/components/analytics/DashboardSummary'
import { LiveOrderTracking } from '@/components/orders/LiveOrderTracking'
import { DeliveryMetrics } from '@/components/analytics/DeliveryMetrics'

export function OrdersDashboard() {
  const [orders, setOrders] = useState<Order[]>([])

  useEffect(() => {
    setOrders(generateOrders(50))
  }, [])

  return (
    <div className="space-y-6">
      {/* Live Order Tracking */}
      <LiveOrderTracking orders={orders} />

      {/* Summary Stats */}
      <DashboardSummary orders={orders} />

      {/* Delivery Performance */}
      <DeliveryMetrics orders={orders} />

      {/* Orders Table */}
      <OrderTrackingTable orders={orders} />
    </div>
  )
} 